/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { PbComponentItemFinderBusinessService } from '../../resources/pb-component-item-finder-business.service';
import { PbComponentItemFinderDialogComponent } from './pb-component-item-finder-dialog.component';

export const pbComponentItemFinderDialogRoute = createDialogRoute({
  component: PbComponentItemFinderDialogComponent,
  init: PbComponentItemFinderBusinessService,
});
